import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Wrapper = styled.div`
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: ${(props) => props.theme.color.light.default};
  overflow: hidden;
`;

export const ItemWrapper = styled.div`
  cursor: pointer;
  display: flex;
  padding: 12px 20px;

  &:hover {
    background: ${(props) => props.theme.color.light.tintDarker};
  }
`;

export const ItemIconWrapper = styled.div`
  margin-right: 10px;
`;

export const ItemIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
  font-weight: 500px;
`;

export const ItemText = styled.div``;
